import { PageTitle } from '@/components/atoms';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ModuleCard from './components/modulecard';
import NNC from '@assets/modules/ncm.png';
import OEE from '@assets/modules/oee.png';
import QUALITY from '@assets/modules/quality.png';
import SCRAP from '@assets/modules/scrap.png';
import { enqueueSnackbar } from 'notistack';
import { useNavigate } from 'react-router';

export default function ModulesPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const waitforit = () => {
    enqueueSnackbar('Coming soon...', { variant: 'default' });
  };

  return (
    <Grid container spacing={2}>
      <PageTitle title={t('Modules')} />
      <ModuleCard
        icon={NNC}
        label="NNC"
        onClick={() => {
          navigate('/nnc/management');
        }}
      />
      <ModuleCard icon={OEE} label="O.E.E" onClick={waitforit} />
      <ModuleCard icon={SCRAP} label="SCRAP" onClick={waitforit} />
      <ModuleCard icon={QUALITY} label="QUALITY CONTROL" onClick={waitforit} />
    </Grid>
  );
}
